import GroupClassWrapper from '../group-class';

const GroupClass = () => <GroupClassWrapper />;

export default GroupClass;
